import { render, staticRenderFns } from "./FoodSaleStatistic.vue?vue&type=template&id=5cb744f0&"
import script from "./FoodSaleStatistic.vue?vue&type=script&lang=js&"
export * from "./FoodSaleStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports